<footer class="footer mt-5">
    <div class="row justify-content-center footer-content py-5">
        <div class="col-10 ps-0">
            <div class="row">
                <div class="col-md-9">
                    <div class="d-flex justify-content-start flex-wrap">
                        <!-- Links for when isMEDProjectEnabled is enabled -->
                        <ng-container *ngIf="isMEDProjectEnabled; else nonMedLinks">
                            <a class="footer-content-link me-3" target="_blank" href="https://www.zeiss.com/meditec/en/legal-information/legal-notice.html">
                                {{ 'FOOTER.MED.MED_TERMS' | translate }}
                            </a>
                            <a class="footer-content-link" href="https://zeiss.ly/rdp-privacy">
                                {{ 'FOOTER.MED.MED_DATA_PRIVACY' | translate }}
                            </a>
                        </ng-container>

                        <!-- Links for when isMEDProjectEnabled is disbled -->
                        <ng-template #nonMedLinks>
                            <a class="footer-content-link me-3" target="_blank" href="assets/legal/arivis_Cloud_Terms_EN.pdf">
                                {{ 'FOOTER.ARIVIS_CLOUD_TERMS' | translate }}
                            </a>
                            <a class="footer-content-link" href="https://www.zeiss.com/data-protection">
                                {{ 'FOOTER.DATA_PROTECTION' | translate }}
                            </a>
                        </ng-template>
                    </div>
                </div>
                <div *ngIf="!isMEDProjectEnabled" class="col-3 nowrap darker">ZEISS {{ currentYear }} | {{ 'MENU.ZEISS_INITIATIVE' | translate }}</div>
            </div>
        </div>
    </div>
</footer>
